import { render, staticRenderFns } from "./promotion-dates.vue?vue&type=template&id=37f00710&scoped=true"
import script from "./promotion-dates.vue?vue&type=script&lang=js"
export * from "./promotion-dates.vue?vue&type=script&lang=js"
import style0 from "./promotion-dates.vue?vue&type=style&index=0&id=37f00710&prod&lang=scss&scoped=true"
import style1 from "./promotion-dates.vue?vue&type=style&index=1&id=37f00710&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f00710",
  null
  
)

export default component.exports